export default {
  YOUTUBE: "YOUTUBE",
  DAILYMOTION: "DAILYMOTION",
  VIMEO: "VIMEO",
};
